module.exports = __webpack_public_path__ + "img/amx-1.871a9f04.webp";